import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";

// TODO 고객사 자동전송여부 확인 API
export const useGetAutoCheck = (setIsOn) => {
  const login = useRecoilValue(loginState); // 로그인 전역변수

  const CurrentInstance = login.company === "LOGEN" ? LogenInstance : LotteInstance;
    return useMutation(
      // TODO API 리퀘스트 정보
      "getAutoCheck",
      () =>
        CurrentInstance.post("/autoCheck", {
          bran_cd: login.branchCode,
        }),
      {
        // 성공 시
        onSuccess: (data) => {
          if (data.result === "00" || data.result === "77") {
            const autoValue = data.data[0].auto;

            if (autoValue === "1") {
              setIsOn(true);
            } else setIsOn(false);
          }
        },
        // 실패 시
        onError: (error) => {
          console.log(error);
        },
      },
    );
};
